import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export type QuestionSheetState = {
  modalVisible: boolean;
  title: string;
  preamble: string;
  description?: string;
  afterImageDescription?: { text: string; props: Record<string, any> };
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onAccept?: () => void;
  onDismiss?: () => void;
  imageRealtivePath?: string;
  imageAltText?: string;
  imageHorizontalPadding?: number;
};

const initialState: QuestionSheetState = {
  modalVisible: false,
  title: '',
  preamble: '',
  primaryButtonText: '',
  secondaryButtonText: '',
  onAccept: () => {},
  onDismiss: () => {}
};

const questionSheetSlice = createSlice({
  name: 'questionSheetSlice',
  initialState,
  reducers: {
    setQuestionSheetVisible(state, action: PayloadAction<boolean>) {
      state.modalVisible = action.payload;
      // reset props when hiding the sheet
      if (!action.payload) {
        state.title = '';
        state.preamble = '';
        state.description = '';
        state.afterImageDescription = undefined;
        state.primaryButtonText = '';
        state.secondaryButtonText = '';
        state.imageRealtivePath = undefined;
        state.imageAltText = '';
        state.imageHorizontalPadding = 0;
      }
    },
    setQuestionSheetVisibleWithProps(state, action: PayloadAction<QuestionSheetState>) {
      state.modalVisible = action.payload.modalVisible;
      state.title = action.payload.title;
      state.preamble = action.payload.preamble;
      state.description = action.payload.description;
      state.afterImageDescription = action.payload.afterImageDescription;
      state.primaryButtonText = action.payload.primaryButtonText;
      state.secondaryButtonText = action.payload.secondaryButtonText;
      state.onAccept = action.payload.onAccept;
      state.onDismiss = action.payload.onDismiss;
      state.imageRealtivePath = action.payload.imageRealtivePath;
      state.imageAltText = action.payload.imageAltText;
      state.imageHorizontalPadding = action.payload.imageHorizontalPadding;
    }
  }
});

export const getSheetProps = (state: RootState) => state.questionSheet;

export const {
  setQuestionSheetVisible,
  setQuestionSheetVisibleWithProps
} = questionSheetSlice.actions;
export default questionSheetSlice.reducer;
